import { type ReactElement, type ReactNode, useState, useEffect, useRef, ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "src/app/store";
import searchImage from "../../../../assests/Icons/search.svg"
import { createEndUser, updateEndUser, endUserReset } from "../../hooks/endUser";
import { getEndUsers, endUsersReset, insertEndUser, deleteEndUser } from "../../hooks/endUsers";
import { getEndUsersByDealerIDForReports, endUserForReportsReset } from "../../hooks/endUsersForReports";
import { getEndUsersByDealerIDForDetailedReports, endUserForDetailedReportsReset } from "../../hooks/endUsersForDetailedReports";
import Button from "src/components/Button"
import EndUserModal from "./EndUserModal";
import EndUserList from "./EndUserList";
import { EndUserType } from "../../types/EndUserType";
import DealerDetails from "./DealerDetails";
import { DealerType } from "src/features/admin/types/DealerType";
import { DealerReport } from "./DealerReport";
import { DealerDetailedReport } from "./DealerDetailedReport";
import DealerReportModal from "./DealerReportModal";
import { useReactToPrint } from "react-to-print";
import dealer from "src/features/admin/hooks/dealer";
import Spinner from "src/components/Spinner";
import { endUserInstancesReset } from "src/features/endUser/hooks/endUserInstances";
import { endUserInstanceReset } from "src/features/endUser/hooks/endUserInstance";
import { optionType } from "src/features/endUserInstance/types/optionType";
import { SearchType } from "src/features/search/types/SearchType";
import Select, { SingleValue, ActionMeta } from 'react-select';
import { apiClient } from "src/utils/Api/apiClient";
import { MACSearchResultType } from "../../types/MACSearchResultType";
import MACSearchErrorModal from "./MACSearchErrorModal";
import DeleteModal from "src/components/DeleteModal";

export interface DealerMainProps {
        dealerID?: string;
}

const initialEndUser = {
        Id: 0,
        EndUserId: "",
        DealerId: 0,
        Name: "",
        Addresses: {
                Address1: "",
                Address2: "",
                City: "",
                State: "",
                Country: "US",
                PostalCode: "",
                AddressType: ""
        },
        EmailId: "",
        Enabled: false,
        PhoneNumber: "",
        TotalNumberOfDoors: 0,
        Notes: "",
        PrimaryContactEmail: "",
        PrimaryContactPhone: "",
        CreatedAt: "",
        ModifiedAt: "",
}

const options: SearchType[] = [
        { value: 'MACAddress', label: 'MAC Address' },
        { value: 'EndUserID', label: 'EndUser ID' },
        { value: 'DealerID', label: 'Dealer ID' },
        { value: 'EmailID', label: 'Email ID' }
]

const macAddressResultType = {
        EndUserId: 0,
        EndUserInstanceId: 0,
        EndUserInstanceLocationId: 0
}

export default function DealerMain(props: DealerMainProps): ReactElement {
        const [isModalOpen, setModalOpen] = useState(false);
        const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
        const [macSerchErrorModalOpen, setMACSearchErrorModalOpen] = useState(false);
        const [isReportModalOpen, setReportModalOpen] = useState(false);
        const [modalTitle, setModalTitle] = useState("");
        const [deleteModalTitle, setDeleteModalTitle] = useState("");
        const [macSerchErrorModalTitle, setMACSearchErrorModalTitle] = useState("");
        const [macSerchErrorMessage, setMACSearchErrorMessage] = useState("");
        const [reportModalTitle, setReportModalTitle] = useState("");


        const [localEndUsers, setLocalEndUsers] = useState<EndUserType[]>([]);
        const [report, setReport] = useState("");
        const [reportType, setReportType] = useState("");
        const [invoiceNumber, setInvoiceNumber] = useState("");
        const { authUser } = useSelector((state: RootState) => state.auth);
        initialEndUser.DealerId = Number(props.dealerID);
        const [selectedEndUser, setEndUser] = useState<EndUserType | undefined>(initialEndUser);
        const dispatch = useDispatch<AppDispatch>();
        const { endUsersLoading, endUsersError, endUsers } = useSelector((state: RootState) => state.endUsers);
        const { endUserLoading, endUserError, endUser } = useSelector((state: RootState) => state.endUser);
        const { endUserForDetailedReportsLoading, endUserForDetailedReportsError, endUserForDetailedReports } = useSelector((state: RootState) => state.endUserForDetailedReports);
        const { endUserForReportsLoading, endUserForReports, endUserForReportsError } = useSelector((state: RootState) => state.endUserForReports);
        const navigate = useNavigate();
        const contentRef = useRef<HTMLDivElement>(null);
        const authorized = authUser?.PasswordProfileId === 1 || authUser?.PasswordProfileId === 2 ? false : true;
        const [macAddressResult, setMACAddressResult] = useState<MACSearchResultType>(macAddressResultType);

        const [searchTypeSelected, setSearchTypeSelected] = useState<SearchType | null>(options[0]);
        const [searchString, setSearchString] = useState<string>('');

        // const AddEndUser = () => {
        //         setModalOpen(true);
        //         setModalTitle("Add EndUser");
        //         setEndUser(initialEndUser);
        // }

        const endUserClicked = (event: React.MouseEvent<HTMLDivElement>) => {
                const id = event.currentTarget.id;
                setModalOpen(true);
                if (id === "") {
                        setModalTitle("Add EndUser");
                        setEndUser(initialEndUser);
                }
                else {
                        setModalTitle("Edit EndUser");
                        setEndUser(endUsers.find(a => a.Id === Number(id)));
                }
        }

        const DeleteEndUserClicked = (event: React.MouseEvent<HTMLDivElement>) => {
                const id = event.currentTarget.id;
                const endUser = endUsers.find(e => e.Id === Number(id));
                setEndUser(endUser);
                setDeleteModalTitle("Delete EndUser");
                setDeleteModalOpen(true);
        }

        const DeleteEndUser = async (doDelete: boolean) => {
                if (doDelete) {
                        await dispatch(deleteEndUser(selectedEndUser));
                }
                setDeleteModalTitle("");
                setDeleteModalOpen(false);
        }

        const handleSubmitEndUser = async (data: EndUserType) => {
                if (modalTitle === "Add EndUser") {
                        await dispatch(createEndUser(data));
                }
                else if (modalTitle === "Edit EndUser") {
                        await dispatch(updateEndUser(data));
                }
        }

        const showReportModal = () => {
                setReportModalTitle("Generate Report")
                setReportModalOpen(true);
        }

        const setReportData = (type: string, invoiceNumber: string) => {
                setReportType(type);
                setInvoiceNumber(invoiceNumber);
        }

        const Close = () => {
                setModalOpen(false);
                dispatch(endUserReset());
        }

        const handleSearchString = (event: ChangeEvent<HTMLInputElement>) => {
                setMACAddressResult(macAddressResultType);
                setSearchString(event.target.value);
        }

        const searchChange = async () => {
                if (searchTypeSelected?.value !== null) {
                        if (searchString.length > 0) {
                                if (searchTypeSelected?.value === "MACAddress") {
                                        try {
                                                const response = await apiClient.get(`endUserInstanceLocation/searchMACAddress/${searchString}`);
                                                setMACAddressResult(response.data);
                                        } catch (dealerError: any) {
                                                console.log(dealerError);
                                                if (dealerError.response.data === "No endUser instances exists.") {
                                                        setMACSearchErrorModalOpen(true);
                                                        setMACSearchErrorModalTitle("Info");
                                                        setMACSearchErrorMessage("This MAC Address is not assigned");
                                                }
                                        }
                                }
                                else if (searchTypeSelected?.value === "EndUserID") {

                                }
                                else if (searchTypeSelected?.value === "DealerID") {

                                }
                                else if (searchTypeSelected?.value === "EmailID") {

                                }
                        } else {
                                console.log("SearchString is required");
                        }
                }
        }

        const searchTypeChanged = (
                newValue: SingleValue<SearchType>,
                actionMeta: ActionMeta<SearchType>
        ) => {
                setSearchTypeSelected(newValue);
        }

        const printCompact = useReactToPrint({ contentRef })

        useEffect(() => {
                if ((reportType.length > 0) && !isReportModalOpen && (invoiceNumber.length > 0)) {
                        printCompact();
                        setInvoiceNumber("");
                }
                setLocalEndUsers(endUsers);
                if (endUser.Id !== 0) {
                        setModalOpen(false);
                        dispatch(insertEndUser(endUser));
                        dispatch(endUserReset());
                }
                else {
                        setLocalEndUsers(endUsers);
                }
        }, [isReportModalOpen, reportType, endUser.Id, endUsers])


        return <>
                {endUsersLoading ?
                        <Spinner title="Loading" />
                        :
                        (
                                <div className="grid grid-rows-[5%_95%] gap-2 h-[inherit]">
                                        <div className="place-content-between flex flex-auto gap-4">
                                                <div className="flex gap-2 basis-full">
                                                        <div className="flex gap-2 w-full">
                                                                <input className="basis-1/2 w-full hover:border-black" type="text" onChange={handleSearchString} />
                                                                <div className="basis-1/2 h-full">
                                                                        <Select
                                                                                className="grid h-full"
                                                                                options={options}
                                                                                value={searchTypeSelected}
                                                                                onChange={searchTypeChanged}
                                                                        />
                                                                </div>
                                                        </div>
                                                        <Button className="basis-1/2" size="sm" type="button" buttonStyle="primary" handleClick={searchChange}>Search</Button>
                                                </div>
                                                <Button className="basis-1/2" size="sm" type="button" buttonStyle="primary" handleClick={showReportModal}>Generate Report</Button>
                                                {/* <Button className="basis-1/2" size="sm" type="button" buttonStyle="primary" disabled={authorized} handleClick={AddEndUser}>Add EndUser</Button> */}
                                        </div>
                                        <div className="flex flex-col gap-2">
                                                <EndUserList macAddressSearchResult={macAddressResult} endUserList={localEndUsers} endUserClick={endUserClicked} deleteEndUserClick={DeleteEndUserClicked} />
                                        </div>
                                        {isModalOpen ?
                                                <EndUserModal dealerId={props.dealerID} title={modalTitle} selectedEndUser={selectedEndUser} isOpen={isModalOpen} onClose={Close} onSubmit={handleSubmitEndUser} />
                                                :
                                                <></>
                                        }
                                        {macSerchErrorModalOpen ?
                                                <MACSearchErrorModal title={macSerchErrorModalTitle} isOpen={macSerchErrorModalOpen} errorMessage={macSerchErrorMessage} onClose={() => setMACSearchErrorModalOpen(false)} />
                                                :
                                                <></>
                                        }
                                        {isDeleteModalOpen ?
                                                <DeleteModal title={deleteModalTitle} delete={DeleteEndUser} isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)} >Do you want to delete Dealer: {selectedEndUser?.Name} ?</DeleteModal>
                                                :
                                                <></>
                                        }
                                        {isReportModalOpen ?
                                                <DealerReportModal dealerId={props.dealerID} title={reportModalTitle} isOpen={isReportModalOpen} onGenerate={(type, invoiceNubmer) => setReportData(type, invoiceNubmer)} onClose={() => setReportModalOpen(false)} />
                                                :
                                                <></>
                                        }
                                        <div className="hidden">
                                                <div ref={contentRef} className="block">
                                                        {
                                                                reportType === "compact" ?
                                                                        <DealerReport invoiceNumber={invoiceNumber} /> : <DealerDetailedReport invoiceNumber={invoiceNumber} />
                                                        }
                                                </div>
                                        </div>
                                </div>
                        )
                }
        </>
}
